const DEFAULT_LOADER_CONFIG = {
  size: 20,
  line: 'round',
  loading: true,
  thickness: '10%',
  emptyThickness: '10%',
  color: '#FFFFFF',
  emptyColor: '#D0E0F280',
};

export const BUTTON_TYPE_TO_LOADER_CONFIG_MAP = {
  primary: DEFAULT_LOADER_CONFIG,
  secondary: {
    ...DEFAULT_LOADER_CONFIG,
    color: '#1565C0',
    emptyColor: '#73A3D94D',
  },
  destructive: {
    ...DEFAULT_LOADER_CONFIG,
    emptyColor: '#F8D7D74D',
  },
  'destructive-outline': {
    ...DEFAULT_LOADER_CONFIG,
    color: '#DD3636',
    emptyColor: '#EB86864D',
  },
  tertiary: {
    ...DEFAULT_LOADER_CONFIG,
    color: '#808080',
    emptyColor: '#9999994D',
  },
  'brand-fill': {
    ...DEFAULT_LOADER_CONFIG,
    emptyColor: '#D0E0F280',
  },
  'brand-flat': {
    ...DEFAULT_LOADER_CONFIG,
    color: '#00564C',
    emptyColor: '#CCDDDB',
  },
  'text-blue': {
    ...DEFAULT_LOADER_CONFIG,
    color: '#1565C0',
    emptyColor: '#73A3D94D',
  },
  'text-grey': {
    ...DEFAULT_LOADER_CONFIG,
    color: '#808080',
    emptyColor: '#9999994D',
  },
};
